var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-product-modal"},[_c('b-modal',{ref:"productModalRef",attrs:{"id":"product-modal","size":"lg","lazy":true,"hide-footer":true}},[_c('ProductModalContent',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentModalProduct),expression:"currentModalProduct"}],attrs:{"product":_vm.currentModalProduct,"group":_vm.currentModalProductGroupName}})],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81e010ca","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/capsule/ProductModal.vue
// module id = Jtsv
// module chunks = 0